var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"listing-card-mini\"><od-listing-status listing=\"$ctrl.listing\" show-active=\"false\"></od-listing-status><div class=\"listing-card-container\"><div class=\"row\"><div class=\"col-xs-7\"><div ng-style=\"{&quot;background-image&quot;: &quot;url(&quot; + $ctrl.listing.listing_photos[0].thumbnail_urls._760x480 + &quot;)&quot;}\" class=\"listing-photo\"></div></div><div class=\"col-xs-5 end-xs listing-card-info text-left\"><div class=\"row\"><b>{{$ctrl.listing | listingDisplayAddress}}, {{$ctrl.listing.address.city}}</b></div><div class=\"row text-small\">{{$ctrl.listing.bedrooms}} bed\n{{$ctrl.listing.bathrooms}} bath\n{{$ctrl.listing.square_footage | number}} ft²</div><div class=\"row listing-card-price text-bold\">{{$ctrl.listing.price_cents | currency}}</div></div></div></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/components/od-listing-card-mini.jade
 ** module id = 3492
 ** module chunks = 3
 **/